import { Component } from '@angular/core';

import {TranslateService} from "@ngx-translate/core";

import {isUserLanguageSupported} from "./shared/util/translate.util";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'motoai-landing-page';

  constructor(private translateService: TranslateService) {
    const browserLanguage = navigator.language || (navigator as any).userLanguage;

    const language = isUserLanguageSupported(browserLanguage);

    this.translateService.setDefaultLang('en-US');
    this.translateService.use(language);
  }
}
